let API_BASE = "/api";
export class ShareConstants {
  public static API_YEAR_REVIEW_SHAREABLE_URL =
    API_BASE + "/users/{userId}/engine/review-year";
}
